<div class="email-drawer-toolbar">
  <div>
    <strong>{{ mode === 'list' ? 'Document email' : mode === 'view' ? 'Email conversation' : replyToMessageId ? 'Reply' : 'Share by email' }}</strong>
    <div class="text-secondary small">{{ messages.length }} message{{ messages.length === 1 ? '' : 's' }} attached</div>
  </div>
  <button *ngIf="mode === 'list'" type="button" class="btn btn-primary btn-sm" (click)="openComposer()">
    <i class="ti ti-plus" aria-hidden="true"></i> New email
  </button>
  <button *ngIf="mode !== 'list'" type="button" class="btn btn-sm" (click)="showMessages()">
    <i class="ti ti-arrow-left" aria-hidden="true"></i> Messages
  </button>
</div>

<app-message-list
  *ngIf="mode === 'list'"
  [messages]="messages"
  [loading]="loading"
  emptyTitle="No email attached yet"
  emptyDescription="Share this document by email. Replies received in your mailbox stay attached here."
  (messageSelected)="openMessage($event)"
  (composeRequested)="openComposer()"
></app-message-list>

<app-message-view
  *ngIf="mode === 'view' && selectedMessage as message"
  [message]="message"
  (backRequested)="showMessages()"
  (replyRequested)="replyToMessage($event)"
></app-message-view>

<form *ngIf="mode === 'compose'" (ngSubmit)="send()">
  <div class="alert alert-info" *ngIf="workspace.out_step_link as link">
    <div class="d-flex align-items-start justify-content-between gap-2">
      <div>
        <strong>External review link</strong>
        <div class="small text-break mt-1">{{ link.url }}</div>
        <div class="small text-secondary mt-1">Expires {{ link.expires_at | date:'medium' }}</div>
      </div>
      <button type="button" class="btn btn-sm" (click)="recreateLink()">Recreate</button>
    </div>
  </div>
  <div class="mb-3">
    <label class="form-label" for="bd-email-account">Send from</label>
    <select id="bd-email-account" class="form-select" name="account" required [(ngModel)]="accountId">
      <option value="" disabled>{{ loading ? 'Loading email accounts…' : 'Select an email account' }}</option>
      <option *ngFor="let account of accounts" [value]="account.id">
        {{ account.display_name }} · {{ account.email_address }}{{ account.is_default ? ' (Default)' : '' }}
      </option>
    </select>
    <small class="form-hint">Uses a connected personal account from Mail.</small>
  </div>
  <div class="mb-3">
    <label class="form-label" for="bd-email-recipient">To</label>
    <input id="bd-email-recipient" type="email" class="form-control" name="recipient" required autocomplete="email" [(ngModel)]="recipient">
  </div>
  <div class="mb-3">
    <label class="form-label" for="bd-email-subject">Subject</label>
    <input id="bd-email-subject" type="text" class="form-control" name="subject" required [(ngModel)]="subject">
  </div>
  <div class="mb-3">
    <label class="form-label" for="bd-email-cc">Cc</label>
    <input id="bd-email-cc" type="text" class="form-control" name="cc" placeholder="name@example.com, colleague@example.com" [(ngModel)]="cc">
    <small class="form-hint">Document contributors are added automatically. Remove any address that should not receive this email.</small>
  </div>
  <div class="mb-3">
    <label class="form-label" for="bd-email-body">Message</label>
    <textarea id="bd-email-body" rows="11" class="form-control" name="body" required [(ngModel)]="body"></textarea>
    <small class="form-hint">{{ replyToMessageId ? 'Your reply stays attached to this document.' : 'The document PDF is attached automatically.' }}</small>
  </div>
  <div class="d-flex justify-content-end gap-2">
    <button type="button" class="btn" (click)="showMessages()">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="sending || !accountId || !recipient.trim() || !subject.trim() || !body.trim()">
      <span class="spinner-border spinner-border-sm me-2" *ngIf="sending"></span>Send email
    </button>
  </div>
</form>
